import { render, staticRenderFns } from "./DiscountDetails.vue?vue&type=template&id=5dd4012a&scoped=true"
import script from "./DiscountDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DiscountDetails.vue?vue&type=style&index=0&id=5dd4012a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4012a",
  null
  
)

export default component.exports